import React from 'react'

const ErrorPage = () => {
  return (
    <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh"
    }}>
        <h1>Error Page</h1>
    </div>
  )
}

export default ErrorPage